import en from './en.json';
import pt from './pt.json';
import es from './es.json';

const messages = {
    pt: pt, // Português (Brasil)
    en: en, // Inglês
    es: es // Espanhol
};

export default messages;
